const getters = {
  listaTramitacoes: (state) => state.listaTramitacoes,
  listaFluxos: (state) => state.listaFluxos,
  listaDestinosFluxo: (state) => state.listaDestinosFluxo,
  listaValidacaoFluxo: (state) => state.listaValidacaoFluxo,
  fluxoSelecionado: (state) => state.fluxoSelecionado,
  destinoSelecionado: (state) => state.destinoSelecionado,
  despachoSelecionado: (state) => state.despachoSelecionado,
  despachoSalvo: (state) => state.despachoSalvo,
  despachoFormatadoSelecionado: (state) => state.despachoFormatadoSelecionado,
  despachoFormatadoSalvo: (state) => state.despachoFormatadoSalvo,
  nivelAcessoSelecionado: (state) => state.nivelAcessoSelecionado,
  hipoteseLegalSelecionada: (state) => state.hipoteseLegalSelecionada,
  listaHipotesesLegais: (state) => state.listaHipotesesLegais,
  tipoDespachoSelecionado: (state) => state.tipoDespachoSelecionado,
  despachoPreparatorio: (state) => state.despachoPreparatorio
}

export default getters
